@for (profile of avatarStackProfiles(); track profile; let i = $index) {
  <rma-profile-avatar
    class="first:ml-0"
    [ngClass]="avatarSize()"
    [avatar]="profile.avatarUrl"
    [name]="profile.profileName"
    [profileType]="profile.profileType"
    [matTooltip]="profile.profileName"
    matTooltipPosition="above" />
}

@if (hasMore()) {
  <div class="bg-blue-10 flex items-center justify-center text-blue-50" [ngClass]="avatarSize()">+{{ more() }}</div>
}
